import { Adapter as o } from "../../../../adapter.js";
import { CheckoutDesignImagesModel as r } from "./images.model.js";
class n extends o {
  adapt(e) {
    return new r({
      favicon: (e == null ? void 0 : e.favicon) ?? "https://static.cheerfy.com/static-resources/default_logo.png",
      background: e == null ? void 0 : e.background
    });
  }
  serialize(e) {
  }
}
export {
  n as CheckoutDesignImagesAdapter
};
//# sourceMappingURL=images.adapter.js.map
